import type { MantineSpacing } from "@mantine/core";

/** The space above and below each divider in the dropdown: between groups, and above the create row or create hint. */
export const DIVIDER_SPACING: MantineSpacing = "xs";

/** Shown in the open list when there are no options to show and nothing to create. */
export const NO_ITEMS_FOUND_LABEL = "Nothing found";
